<template>
  <div id="app" class="main-layout-page">
    <div class="fl-page big-container">
      <navigation-top-bar v-if="guestEmail" 
        :guestEmail="guestEmail">
      </navigation-top-bar>
      <Header />
      <!-- <navigation-bar-sticky>
      </navigation-bar-sticky>
      <navigation-bar-fixed v-show="showFixed">
      </navigation-bar-fixed >  -->
        <router-view/>
      <shared-charters-footer>
      </shared-charters-footer>
    </div>
  </div>
</template>

<script>
// import store from 'vuex';
import { mapState } from 'vuex'
import NavigationTopBar from './views/Header/NavigationTopBar';
import Header from "./views/Header/Header";
// import NavigationBarSticky from './views/Header/NavigationBarSticky';
// import NavigationBarFixed from './views/Header/NavigationBarFixed';
import SharedChartersFooter from './views/Footer/Footer';
import NavBarMixin from './mixins/NavigationBarMixin';

export default {
  /* metaInfo: {
		script: [
      {src:'https://www.googletagmanager.com/gtag/js?id=AW-563602882',async:true },
      { innerHTML: `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-563602882');`},
    ]
	}, */
  components: {
    NavigationTopBar,
    // NavigationBarSticky,
    // NavigationBarFixed,
    SharedChartersFooter,
    Header
  },
  mixins: [NavBarMixin],
  computed: {
    ...mapState('guests', {
      guestEmail: state => state.email ? state.email : null
    })
  },
  mounted() {
    //Add google tags to head
    let script1 = document.createElement('script');
    script1.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-563602882');`;  
    let script2 = document.createElement('script');
    script2.async = true;
    script2.src="https://www.googletagmanager.com/gtag/js?id=AW-563602882";
    document.head.appendChild(script1);
    document.head.appendChild(script2);
    let script3 = document.createElement('script');
    script3.async = true;
    script3.defer = true;
    script3.src="//js.hs-scripts.com/8298109.js";
    script3.type="text/javascript";
    document.head.appendChild(script3);

    //Activate Google analytics
    let script4 = document.createElement('script');
    script4.innerHTML = `(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

    ga('create', 'UA-178630887-1', 'auto');
    ga('send', 'pageview');`;

    document.head.appendChild(script4);

    let script5 = document.createElement('script');
    script5.innerHTML = `(function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2056211,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
    document.head.appendChild(script5);

    let script6 = document.createElement('script');
    script6.innerHTML = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '858013925021136');
    fbq('track', 'PageView');`;
    document.head.appendChild(script6);

    let script7 = document.createElement('script');
    script7.async = true;
    script7.src="https://www.googletagmanager.com/gtag/js?id=G-PM9EEDVE22";
    document.head.appendChild(script7);

    let script8 = document.createElement('script');
    script8.innerHTML = `window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-PM9EEDVE22');`;
    document.head.appendChild(script8);

    let script10 = document.createElement('script');
    script10.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WBSSR6M');`;
    document.head.appendChild(script10);

    let script11 = document.createElement('noscript');
    script11.innerHTML = `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WBSSR6M"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
    document.body.appendChild(script11);

    let script12 = document.createElement('script');
    script12.type='text/javascript'
    script12.innerHTML = `window.fbAsyncInit = function() {
          FB.init({
            xfbml            : true,
            version          : 'v10.0'
          });
        };
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));`;
    document.body.appendChild(script12);

    let script13 = document.createElement('div');
    script13.setAttribute('class','fb-customerchat')
    script13.setAttribute('attribution','page_inbox')
    script13.setAttribute('page_id','101685911715005')

    document.body.appendChild(script13);

    // Event snippet for Sign-up conversion page
    /* let script10 = document.createElement('script');
    script10.innerHTML = `function gtag_report_conversion(url) {
      var callback = function () {
        if (typeof(url) != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
          'send_to': 'AW-563602882/L2NECOOLovQBEMLL34wC',
          'event_callback': callback
      });
      return false;
    }`;
    document.head.appendChild(script10); */
  },
}
</script>

<style>



  
</style>